import { useEffect, useRef, useState } from 'react';

export function useAuthFile(fileUrl: string | null | undefined): string | null {
  const [blobUrl, setBlobUrl] = useState<string | null>(null);
  const currentRef = useRef<string | null>(null);

  useEffect(() => {
    if (!fileUrl) {
      if (currentRef.current) {
        URL.revokeObjectURL(currentRef.current);
        currentRef.current = null;
      }
      setBlobUrl(null);
      return;
    }
    const controller = new AbortController();
    let alive = true;

    fetch(fileUrl, {
      headers: { Authorization: 'Bearer ' + localStorage.getItem('colibri_token') },
      signal: controller.signal,
    })
      .then((res) => {
        if (!res.ok) throw new Error(String(res.status));
        return res.blob();
      })
      .then((blob) => {
        if (!alive) return;
        const created = URL.createObjectURL(blob);
        // старый blob живёт до прихода нового (не битый img при смене файла)
        if (currentRef.current) URL.revokeObjectURL(currentRef.current);
        currentRef.current = created;
        setBlobUrl(created);
      })
      .catch(() => {
        if (!alive) return;
        if (currentRef.current) {
          URL.revokeObjectURL(currentRef.current);
          currentRef.current = null;
        }
        setBlobUrl(null);
      });

    return () => {
      alive = false;
      controller.abort();
    };
  }, [fileUrl]);

  // revoke только при размонтировании
  useEffect(
    () => () => {
      if (currentRef.current) URL.revokeObjectURL(currentRef.current);
    },
    [],
  );

  return blobUrl;
}
